import {Field, FIELD_TYPE_INFO, FieldType, Primitive} from "../../../../Types";
import {PHP_TYPE_MAP, PhpType, phpTypeToFieldType} from "../../../../features/schemaManageSlice";
import styled from "styled-components";
import {ColumnInfo, EditValueI} from "./EditTableRecord";
import {getColumnValue} from "../../../functions";
import {SqlQuery} from "../../../schemaManage/back/BackTableFieldViewTable";
import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight, faDatabase} from "@fortawesome/free-solid-svg-icons";
import {faPhp} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeTypeIcon} from "../../../misc/TypeIcon";
import {getReadableTextColor} from "../../../filters/FilterMultiMapValue";
import moment from "moment";
import RawEditForm from "./RawEditForm";
import RawEditStringTextarea from "./forms/RawEditStringTextarea";

type EditColumnSchema = ColumnInfo & { frontType: FieldType, simpleType: FieldType };

type PropsI = {
    value: EditValueI;
    currentValue: Primitive;
    info: ColumnInfo;
    schema?: Field;
    isNew?: boolean
    setValue: (column: string, curr: EditValueI) => void
};

export default function EditColumnRow({value, currentValue, info, schema, setValue, isNew = false}: PropsI) {
    const simpleType = phpTypeToFieldType(info.php_type);
    const frontType = schema ? schema.type : simpleType
    const [selectedType, setSelectedType] = useState<"simple" | "front">(simpleType === frontType ? "simple" : "front")


    const setDefault = () => {
        let val: EditValueI;
        if (info.expr_type === "FUNCEXPR") {
            val = {
                isEdited: true,
                format: "expression",
                value: info.column_default,
                invalid: false
            };
        } else {
            const v = stringToPrimitiveValue(info.column_default!, info.php_type);
            val = {
                isEdited: currentValue !== v,
                format: "const",
                value: v,
                invalid: false
            };
        }
        setValue(info.column_name, val)
    };

    const onChange = (v: Primitive, invalid = false) => setValue(info.column_name, ({
        ...value,
        value: v,
        isEdited: v !== currentValue || value.format === "expression",
        invalid: invalid || (value.format === "expression" && v === '')
    }));
    const isEditable = !info.is_primary_key

    return <Container>
        <td className={'info-td'}>
            <div className={'info-cell'}>
                <div className="name">{info.column_name}</div>
                <div className="types">
                    <div className="type db"><FontAwesomeIcon className={'fa-color'} icon={faDatabase}
                                                              size={"1x"}/><span
                        className="type-badge db-type-badge">{info.data_type}</span></div>
                    <div className="type php"><FontAwesomeIcon className={'fa-color-text'} icon={faArrowRight}
                                                               size={"1x"}/>
                        <FontAwesomeIcon className={'fa-color'} icon={faPhp} size={"1x"}/>
                        <span
                            className={'type-badge'}
                            style={{
                                background: PHP_TYPE_MAP[info.php_type].color,
                                color: getReadableTextColor(PHP_TYPE_MAP[info.php_type].color)
                            }}>{PHP_TYPE_MAP[info.php_type].desc}</span>
                    </div>
                    {schema &&
                        <div className="type front"><FontAwesomeIcon className={'fa-color-text'} icon={faArrowRight}
                                                                     size={"1x"}/> <FontAwesomeTypeIcon
                            className={'fa-color'} size={"1x"} type={frontType}/><span className={'type-badge'} style={{
                            background: FIELD_TYPE_INFO[frontType].color,
                            color: getReadableTextColor(FIELD_TYPE_INFO[frontType].color)
                        }}>{frontType}</span></div>}
                </div>
                {info.column_default && <div className="def">
                    <SqlQuery sqlQuery={info.column_default}/>
                </div>}
                {info.is_foreign_key && <div className="fk">
                    FK <b>{info.foreign_schema}.{info.foreign_table}</b> стовпчик <b>{info.foreign_column}</b>
                </div>}
                <small className="comment">{info.comment}</small>
            </div>
        </td>
        <td className={"format-cell"}>
            {isEditable && <div className="value-type">
                <div className={"check"}>
                    <label htmlFor={"constVal" + info.column_name}>
                        <input id={"constVal" + info.column_name}
                               onChange={e => setValue(info.column_name, getValueForFormat(currentValue, value, e.target.value as any, info, frontType, schema))}
                               value={"const"}
                               type="radio"
                               checked={value.format === 'const'}/>
                        Значення
                    </label>
                </div>
                <div className={"check"}>
                    <label htmlFor={"expre" + info.column_name}>
                        <input id={"expre" + info.column_name}
                               type="radio"
                               value={"expression"}
                               onChange={e => setValue(info.column_name, getValueForFormat(currentValue, value, e.target.value as any, info, frontType, schema))}
                               checked={value.format === 'expression'}/>
                        Вираз
                    </label>
                </div>
                {!info.not_null && <div className={"check"}>
                    <label htmlFor={"nullVal" + info.column_name}>
                        <input id={"nullVal" + info.column_name} onChange={e => {
                            setValue(info.column_name, getValueForFormat(currentValue, value, 'null', info, frontType, schema))
                        }} type="radio" checked={value.format === 'null'}/>
                        NULL
                    </label>
                </div>}
                {info.column_default && <div>
                    <button className={'btn-cmn def-btn'} onClick={setDefault}>Стандарт</button>
                </div>}
            </div>}
        </td>
        <td className={'value-td'}>
            <div className={'value-cell'}>
                {!isNew && <div className="current">
                    <div>Поточне:</div>
                    <div>
                        {schema ? getColumnValue(currentValue, schema) : String(currentValue)}
                    </div>
                </div>}
                {!isNew && <hr className="value-div"/>}
                {value.format === "null" && <div className="new">
                    <i className={"null-value"}>NULL</i></div>}
                {isEditable && value.format === "const" && <RawEditForm value={value.value as any}
                                                                        onChange={onChange}
                                                                        schema={schema}
                                                                        name={info.column_name} type={frontType}
                                                                        isSimple={true}/>}
                {isEditable && value.format === "expression" &&
                    <RawEditStringTextarea value={value.value as any} onChange={onChange} name={info.column_name}/>}
                {value.invalid && <div className="err">
                    Неправильне значення
                </div>}
            </div>

        </td>

    </Container>
}


const Container = styled.tr`
    padding: var(--td-padding);

    border-top: 2px solid var(--table-border-color);
    border-bottom: 2px solid var(--table-border-color);
    font-size: 1rem;

    & .format-cell {
        width: 1%;
    }

    & td {
        vertical-align: top;
        border-left: 2px solid var(--table-border-color);
        border-right: 2px solid var(--table-border-color);
    }

    & .info-td {
        max-width: 600px;
    }

    & .value-td {
        width: 100%;
    }

    & .info-cell {
        display: inline-flex;
        flex-flow: column;
        gap: .2rem;
        flex-grow: 1;
        width: 100%;


        & .def {
            max-width: 500px;
        }

        & .comment {
            font-size: 0.75rem;
        }

        & .name {
            background: wheat;
            color: black;
            padding: .2rem;
            border-radius: .2rem;
        }

        & .types {
            display: flex;
            gap: .5rem;
            align-items: center;
            flex-wrap: wrap;

            .type {
                display: flex;
                gap: .5rem;
                align-items: center;

                .type-badge {
                    padding: .2rem;
                    border-radius: .2rem;
                }

                .db-type-badge {
                    color: white;
                    background: black;
                }
            }
        }
    }

    & .value-type {
        display: inline-flex;
        flex-flow: column;
        gap: .2rem;

        & .check {
            white-space: nowrap;
        }

        & .def-btn {
            width: 100%;
            text-align: center;
        }
    }

    & .value-cell {
        display: inline-flex;
        flex-flow: column;
        gap: .4rem;
        width: 100%;

        & .current {
            display: flex;
            gap: .5rem;
            align-items: center;
            flex-wrap: wrap;
        }

        & .value-div {
            width: 100%;
            height: .2rem;
            background: var(--table-action-color);
        }

        & .err {
            color: red;
            padding: .2rem;
            border-radius: .2rem;
            background: black;
        }

    }
`

function getValueForFormat(currentValue: Primitive, editValue: EditValueI, newFormat: EditValueI['format'], info: ColumnInfo, type: FieldType, schema?: Field,): EditValueI {

    let val = {...editValue, format: newFormat}
    if (newFormat === "const") {
        if (currentValue !== null)
            val.value = currentValue
        else
            val.value = getDefaultValueForType(type, info, schema)
        val.isEdited = currentValue !== val.value
        val.invalid = false
    } else if (newFormat === "expression") {
        if (info.expr_type === "FUNCEXPR")
            val.value = info.expr
        else {
            val.value = ''
            val.invalid = true
        }
        val.isEdited = true
    } else {
        val.value = null
        val.isEdited = currentValue !== null
        val.invalid = false
    }
    return val
}

export function getDefaultValueForType(type: FieldType, info: ColumnInfo, schema?: Field,) {
    switch (type) {
        case "string":
        case "url":
        case "tel":
        case "image":
        case "email":
        case "json":
            return ''
        case "number":
            return 0
        case "map":
            if (!!schema && !!schema.map?.values && Object.values(schema.map.values).length > 0)
                return Object.values(schema.map.values)[0].rawValue
            if (info.php_type === "float" || info.php_type === "int")
                return 0;
            if (info.php_type === "string")
                return ''
            if (info.php_type === "date")
                return moment().locale('en').format(schema?.datetimeFormat || 'yyyy-MM-DD')
            if (info.php_type === "timestamp")
                return moment().locale('en').format(schema?.datetimeFormat || 'yyyy-MM-DDTHH:mm')
            return ''
        case "datetime":
            return moment().locale('en').format(schema?.datetimeFormat || 'yyyy-MM-DDTHH:mm')
        case "date":
            return moment().locale('en').format(schema?.datetimeFormat || 'yyyy-MM-DD')
        case "time":
            return moment().format(schema?.datetimeFormat || "HH:mm")
        case "boolean":
            return false
        default:
            return ''
    }

}

export function stringToPrimitiveValue(value: string, type: PhpType): Primitive {
    if (value === null) return null;

    switch (type) {
        case "int": {
            const parsed = parseInt(value, 10);
            return Number.isNaN(parsed) ? 0 : parsed;
        }
        case "float": {
            const parsed = parseFloat(value);
            return Number.isNaN(parsed) ? 0 : parsed;
        }
        case "bool": {
            return value.toLowerCase() === "true";
        }
        case "timestamp":
        case "date":
        case "string":
            return value; // leave as-is (string)
        default:
            // Exhaustive check (should never happen if PhpType is correct)
            return value;
    }
}

function enrichFrontType(columnSchema: ColumnInfo, fieldSchema: Field | undefined): EditColumnSchema {

    const simpleType = phpTypeToFieldType(columnSchema.php_type);
    if (!fieldSchema)
        return {...columnSchema, frontType: simpleType, simpleType: simpleType}

    return {...columnSchema, frontType: fieldSchema.type, simpleType: simpleType};
}
